import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type ActivateInactiveAccountMutationVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
}>;

export type ActivateInactiveAccountMutationResult = { __typename?: 'Mutation' } & {
  activateInactiveAccount?: GraphQLTypes.Maybe<
    { __typename?: 'ActivateInactiveAccountPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const ActivateInactiveAccountDocument = gql`
  mutation activateInactiveAccount($accountId: String!) {
    activateInactiveAccount(accountId: $accountId) {
      errors {
        message
        path
      }
    }
  }
`;
